/* global angular, $, _, Modernizr */
// Create templates module for ngTemplates to attach to
angular.module('ua5Templates', []);
angular.module('ua5App.index', []);
angular.module('ua5App.index.artist', ['angular-carousel']);
angular.module('ua5App.index.list', []);
angular.module('ua5App.index.tag', []);
angular.module('ua5App.index.blog', []);
angular.module('ua5App.index.credits', []);
angular.module('ua5App.index.roundtable', []);
angular.module('ua5App.index.about', []);
angular.module('ua5App.index.search', []);
// Create parent module for application
angular.module('ua5App', [
    'ngAnimate',
    'ngTouch',
    'ngResource',
    'ngSanitize',
    'ua5Templates',
    'ui.router',
    'angulartics',
    'angulartics.google.analytics',
    'angularModalService',
    'ua5App.index',
    'ua5App.index.list',
    'ua5App.index.search',
    'ua5App.index.tag',
    'ua5App.index.blog',
    'ua5App.index.credits',
    'ua5App.index.roundtable',
    'ua5App.index.about',
    'ua5App.index.artist'
])
    .constant('BREAKPOINTS', {
        MOBILE: 767,
        TABLET: 991,
        LAPTOP: 1199,
        DESKTOP: 1430
    })
    .config(['$locationProvider', function($locationProvider) {
        $locationProvider.html5Mode(true);
    }])
    .config(['$analyticsProvider', function($analyticsProvider) {
        //-- Prevents bounce rate of 0.01
        $analyticsProvider.firstPageview(false);

        //-- Includes base href in the URL
        $analyticsProvider.withBase(true);
    }])
    .factory('PreviousState', [function() {
        var previousState;
        return {
            get: function() {
                return previousState;
            },
            set: function(state) {
                previousState = state;
            }
        };
    }])
    .run(['$rootScope', 'FacebookService', 'PreviousState', '$location', function($rootScope, FacebookService, PreviousState, $location) {
        var fbId;
        var near = false;

        // Set to dev mode if `dev` is present in URL. Note that `dev=false`
        // will still set dev to true.
        $rootScope.dev = $location.search().dev ? true : false;

        $rootScope.$on('$stateChangeSuccess', function(e, toState, toStateParams, fromState, fromStateParams) {
            PreviousState.set({
                url: fromState.url,
                params: fromStateParams
            });
            setTimeout(function() {
                $('p').widowFix();
            }, 0);
        });

        // Switch FB ID based on host
        switch ($location.host()) {
            // UA5 server
            case 'storylines.johnny5.ua5host.com':
                fbId = '639339736203197';
                break;
            // Staging
            case 'exhibitions-staging.guggenheim.org':
                fbId = '639339849536519';
                break;
            // Production
            case 'exhibitions.guggenheim.org':
                fbId = '635046293299208';
                break;
            // Development environment
            default:
                fbId = '635046696632501';
                break;
        }

        FacebookService.init(fbId);

        if (!Modernizr.touch) {
            $(document).on('mousemove', _.throttle(function(e) {
                // Alert app when near footer
                if (
                    e.pageY >= $(this).height() * 0.65 &&
                    !near
                ) {
                    near = true;
                    $rootScope.$broadcast('nearFooter');
                } else if (
                    e.pageY < $(this).height() * 0.85 &&
                    near
                ) {
                    near = false;
                    $rootScope.$broadcast('farFromFooter');
                }
            }, 200));
        }

    }])
    .factory('MetaFactory', [function() {
        var defaults = {
            // Default options / values
            title: 'Storylines: Contemporary Art at the Guggenheim',
            description: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines',
            ogTitle: 'Storylines: Contemporary Art at the Guggenheim',
            ogDescription: 'Every work of art has a story. Explore 100+ contemporary works from the @Solomon R. Guggenheim Museum collection in Storylines',
            ogImage: window.location.href + '/assets/img/storylines-share.jpg',
            ogUrl: window.location.href
        };
        var meta = {};
        angular.extend(defaults, meta);
        function strip(html) {
            var tmp = document.createElement('DIV');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        }
        return {
            set: function(src) {
                var newSrc = {};
                // Strip HTML from values
                angular.forEach(src, function(value, key) {
                    newSrc[key] = strip(value);
                });
                angular.forEach(defaults, function(value, key) {
                    if (!newSrc.hasOwnProperty(key)) {
                        newSrc[key] = value;
                    }
                });
                meta = angular.extend(meta, newSrc);
            },
            get: function() {
                return meta;
            }
        };
    }])
    .controller('MetaCtrl', ['MetaFactory', '$scope', function(MetaFactory, $scope) {
        $scope.meta = MetaFactory.get();
    }])
    .directive('app', ['$rootScope', function($rootScope) {
        return {
            restrict: 'A',
            link: function() {
                var $$window = $(window);
                $$window.on('resize', function() {
                    $rootScope.$broadcast('app:resized');
                });
                $$window.on('keydown', function(e) {
                    // Escape key
                    if (e.keyCode === 27) {
                        $rootScope.$broadcast('app:escapePressed');
                    }
                });
            }
        };
    }])
;
